import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_EVENTOS,
  ALL_EVENTOS,
  LOADING_ALL_EVENTOS,
} from './ReportesReducer';
import {
  deleteReportesService,
  allReportesService,
  oneReportesService,
  saveReportesService,
} from './ReportesService';

export const allReportesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_EVENTOS, payload: true });
    const res = await allReportesService(params);
    dispatch({ type: ALL_EVENTOS, payload: res.data });
    dispatch({ type: LOADING_ALL_EVENTOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_EVENTOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveReportesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveReportesService(id, data);
    notify(res.data.message);
    await allReportesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoReportesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_EVENTOS, payload: data });
};

export const oneReportesAction = async (dispatch, id) => {
  try {
    const res = await oneReportesService(id);
    await setActivoReportesAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteReportesAction = async (
  { dispatch, notify },

  id,
  params,
) => {
  try {
    const res = await deleteReportesService(id);
    notify(res.data.message);
    await setActivoReportesAction(dispatch, null);
    await allReportesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
